import React, { useEffect, useState, useRef } from 'react'; // Asegúrate de importar useRef
import { Table, Button, Modal, message } from 'antd';
import { getSoloIndicadores } from '../services/IndicadoresService';
import FormularioFicha from '../components/FormularioFichas/FormularioFichas';
import { eliminarFichaService } from '../services/FormularioService';

const GestorFormulario = () => {
    const [indicadores, setIndicadores] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false); 
    const [selectedJson, setSelectedJson] = useState(null); 
    const [indicadorId, setIndicadorId] = useState(null); 
    const [buttonText, setButtonText] = useState("Agregar Ficha");

    // Crear la referencia
    const formRef = useRef();

    const fetchIndicadores = async () => {
        try {
            const response = await getSoloIndicadores(); 
            setIndicadores(response.data); 
        } catch (error) {
            console.error('Error al obtener los indicadores:', error);
        }
    };

    useEffect(() => {
        fetchIndicadores();
    }, []);

    const handleAgregarJson = (record) => {
        setSelectedJson(record.fichas_json); 
        setIndicadorId(record.indicador_id); 
        setButtonText(record.fichas_json ? "Actualizar Ficha" : "Agregar Ficha");
        showModal(); 
    };

    const handleEliminarFicha = async (id) => {
        const confirm = window.confirm("¿Estás seguro de que deseas eliminar esta ficha?");
        if (confirm) {
            try {
                await eliminarFichaService(id);
                message.success("Ficha eliminada correctamente.");
                fetchIndicadores();
            } catch (error) {
                console.error('Error al eliminar la ficha:', error);
                message.error("Error al eliminar la ficha.");
            }
        }
    };

    const columns = [
        {
            title: 'Nombre del Indicador',
            dataIndex: 'indicador',
        },
        {
            title: 'Código Indicador',
            dataIndex: 'codigo_indicador', 
        },
        {
            title: 'Acción',
            dataIndex: 'indicador_id',
            render: (id, record) => (
                <div>
                    <Button onClick={() => handleAgregarJson(record)} type="primary" style={{ marginRight: '8px' }}>
                        {record.fichas_json ? "Actualizar Ficha" : "Agregar Ficha"}
                    </Button>
                    {/* Botón de Eliminar solo si hay una ficha */}
                    {record.fichas_json && (
                        <Button onClick={() => handleEliminarFicha(record.indicador_id)} color="danger" variant="solid">
                            Eliminar Ficha
                        </Button>
                    )}
                </div>
            ),
        },
    ];

    const showModal = () => {
        setIsModalVisible(true);
    };
    
    const handleModalCancel = () => {
        setIsModalVisible(false);
        setSelectedJson(null); 
        setIndicadorId(null); 
        fetchIndicadores();
        
        // Llamar a la función de reset en FormularioFicha para volver al paso 1
        formRef.current?.resetFields();
        formRef.current?.setCurrentStep(1); // Restablecer el paso al valor inicial
    };
    

    return (
        <div style={{ padding: '20px' }}>
            <h1 style={{textAlign: 'center'}}>Gestor de Ficha Técnica</h1>
            <p>Aquí puedes gestionar tus fichas técnicas.</p>
            <Table 
                dataSource={indicadores} 
                columns={columns} 
                rowKey="indicador_id" 
                pagination={{ pageSize: 10 }} 
                bordered 
            />
            <Modal
                open={isModalVisible} 
                onCancel={handleModalCancel}
                footer={null}
                width={1100} 
                style={{ top: "10px", maxHeight: "700px" }} 
            >
                <div style={{ height: "640px", overflowY: "auto", overflowX: "hidden" }}>
                    <FormularioFicha 
                        ref={formRef} // Pasa la referencia al componente FormularioFicha
                        json={selectedJson} 
                        indicadorId={indicadorId} 
                        onSuccess={handleModalCancel}
                    />                   
                </div>
            </Modal>
        </div>
    );
};

export default GestorFormulario;
